import React from "react";
import classNames from "classnames";
import { color, easingBounce, easingBounceMs } from "..";
import { styled } from "@linaria/react";

const OPENED = "opened";

const Container = styled.div``;

const Title = styled.p`
  cursor: pointer;
  color: ${color.carbon800};
  display: flex;
  align-items: center;
  margin-top: 10px;
  :after {
    display: block;
    content: "";
    width: 0.5em;
    height: 0.5em;
    border-width: 0 1px 1px 0;
    border-style: solid;
    transition: transform ${easingBounceMs}ms ${easingBounce};
    transform-origin: 60% 60%;
    margin-left: 8px;
  }
  &:not(.${OPENED}):after {
    transform: rotate(45deg);
  }
  &.${OPENED}:after {
    transform: rotate(225deg);
  }
`;

const ExpandedSection = styled.div`
  margin-top: 0;
  visibility: hidden;
  overflow: hidden;
  max-height: 0;

  &.${OPENED} {
    margin-top: 10px;
    max-height: 300px;
    visibility: visible;
    transition: all 0.1s linear;
    overflow: auto;

    /* hide scrollbar while animating */
    @keyframes hide-scroll {
      from,
      to {
        overflow: hidden;
      }
    }
    animation: 0.2s backwards hide-scroll;
  }
`;

interface P {
  title: string;
  expanded: boolean;
  handleClick?: () => void;
  className?: string;
  children: React.ReactNode;
}

const SmallCollapse = ({ title, expanded, handleClick, className, children }: P) => (
  <Container className={className}>
    <Title onClick={handleClick ?? undefined} className={classNames({ [OPENED]: expanded })}>
      {title}
    </Title>
    <ExpandedSection className={classNames({ [OPENED]: expanded })}>{children}</ExpandedSection>
  </Container>
);

export default React.memo(SmallCollapse);
